display: flex; flex-direction: row; align-items: center; justify-content: flex-start;
<template>
  <div class="set_scroll_response">
    <div class="variable_edit">
      <p class="mr8">横轴坐标</p>
      <el-input v-model="positionProxy[0]" @change="changePosition(0, $event)" suffix="px" placeholder=""></el-input>
    </div>
    <div class="variable_edit mt8">
      <p class="mr8">纵轴坐标</p>
      <el-input v-model="positionProxy[1]" @change="changePosition(1, $event)" placeholder=""></el-input>
    </div>
    <div class="mt16">
      <div class="getDataBtn" @click="$emit('save')">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "variable"
  },
  props: {
    variable: Array,
    position: Array,
    componentVariables: Array,
    eventVariables: Array
  },
  computed: {
    positionProxy: {
      get() {
        return this.position
      },
      set(val) {
        this.$emit("update:position", val)
      }
    }
  },
  methods: {
    changePosition(index, value) {
      const arr = [...this.positionProxy]
      arr.map(item => (item.length ? item.replaceAll("(())", "").replaceAll("{{}}", "") : item))
      this.$event
        .checkMatchStr(value, { componentVariables: this.componentVariables, eventVariables: this.eventVariables })
        .then(res => {
          const { variables } = res
          //有变量
          this.variable.length = 0
          if (variables?.length) {
            variables.forEach(it => this.variable.push(it))
          }
        })
        .catch(err => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "warning",
            message: err.msg + ",已为您将错误数据保存至剪切板，请检查后重新输入"
          })
          this.copyToClip(value)
          console.log(this.positionProxy, index)
          arr[index] = ""
          this.positionProxy = arr
        })
    }
  }
}
</script>

<style scoped>
.variable_edit {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.variable_edit > p {
  width: 30%;
}
.set_scroll_response {
  padding: 16px 24px;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
</style>
